// `MeResponse`, no `SessionVendor`: lo que efectivamente se guarda es la respuesta de
// login/refresh (que trae `tenantStatus`), y antes el tipo declarado (`SessionVendor`)
// no lo incluía — eso invisibilizaba bugs de tipo "el status no llegó al storage".
import type { MeResponse } from '@/types'

const TOKEN_KEY = 'ps_token'
const VENDOR_KEY = 'ps_vendor'

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token)
}

export function getStoredVendor(): MeResponse | null {
  try {
    const raw = localStorage.getItem(VENDOR_KEY)
    return raw ? (JSON.parse(raw) as MeResponse) : null
  } catch {
    return null
  }
}

export function setStoredVendor(vendor: MeResponse): void {
  localStorage.setItem(VENDOR_KEY, JSON.stringify(vendor))
}

export function clearSession(): void {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(VENDOR_KEY)
}

/** Decodifica el payload del JWT sin verificar la firma (solo para UX: expiración/rol). */
function decodeJwtPayload<T>(token: string): T | null {
  try {
    const payload = token.split('.')[1]
    const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
    return JSON.parse(json) as T
  } catch {
    return null
  }
}

/** Lee el `exp` del JWT sin verificar la firma (solo para UX de expiración). */
export function isTokenExpired(token: string | null): boolean {
  if (!token) return true
  const claims = decodeJwtPayload<{ exp?: number }>(token)
  return !claims?.exp || claims.exp * 1000 < Date.now()
}

/** Lee el `role` del JWT sin verificar la firma (solo para ruteo del front). */
export function getTokenRole(token: string | null): string | null {
  if (!token) return null
  return decodeJwtPayload<{ role?: string }>(token)?.role ?? null
}
